/*
  VSB every feature (sections/vsb-features-all): the "Show all" button draws
  the groups folded behind it, which wait in <template> elements until then.
  Set up once the section nears the screen (vsbWhenNear), or on first focus.
*/

if (!customElements.get('d-features')) {
  customElements.define('d-features', class extends HTMLElement {
    connectedCallback() {
      const init = () => {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        this.querySelector('.d-features__more button')?.addEventListener('click', (e) => {
          this.querySelectorAll('template[data-fold]').forEach((t) => t.replaceWith(t.content.cloneNode(true)));
          e.currentTarget.parentElement.remove();
        });
      };
      this.addEventListener('focusin', init, { once: true });
      if (window.vsbWhenNear) window.vsbWhenNear(this, init); else init();
    }
  });
}
